import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import type MedicationMolecule from "parog-web/models/medication-molecule";
import type MedicationPresentation from "parog-web/models/medication-presentation";
export default class MedicationSpecialty extends Model {
  @attr("string") declare administrationRoute: string;
  @attr("string") declare brand: string;
  @attr("string") declare cisCode: string;
  @attr("string") declare dose: string;
  @attr("string") declare galenic: string;
  @attr("string") declare longDescription: string;
  @belongsTo("medication-molecule", {
    async: false,
    inverse: "medicationSpecialties"
  })
  declare medicationMolecule: MedicationMolecule;
  @hasMany("medication-presentation", {
    async: false,
    inverse: "medicationSpecialty"
  })
  declare medicationPresentations: MedicationPresentation[];
  @attr("string") declare shortDescription: string;
  @attr("string") declare state: string;
  @attr("string") declare uid: string;
  @attr("string") declare unit: string;

  get molecule() {
    return {
      code: this.medicationMolecule.atc,
      label: this.medicationMolecule.label
    };
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "medication-specialty": MedicationSpecialty;
  }
}
